import axios from 'axios';
import qs from 'qs';
import { noneToEmptyStr } from '@/utils/util';
import router from '@/router';

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = '/dev-api/';
} else {
  axios.defaults.baseURL = '/api/';
}

axios.defaults.withCredentials = true;

// 返回错误码处理
function errorCodeHandle(errorResponse) {
  switch (errorResponse.status) {
    case 401:
      router.push({ name: 'login' });
      break;
    default:
      console.log(errorResponse);
      break;
  }
}

// 表单请求
axios.formRequest = axios.create({
  baseUrl: axios.defaults.baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  transformRequest: [
    function (data) {
      if (Object.prototype.toString.call(data) === '[object Object]') {
        for (const k in data) {
          data[k] = noneToEmptyStr(data[k]);
        }
      }
      return qs.stringify(data, { arrayFormat: 'indices' });
    },
  ],
});
axios.formRequest.interceptors.request.use(
  config => config,
  error => Promise.reject(error),
);

axios.formRequest.interceptors.response.use(
  response => response.data,
  (error) => {
    if (error.response) {
      errorCodeHandle(error.response);
    }

    return Promise.reject(error);
  },
);

export default axios;
